<script>
    import Shared     from './Shared.svelte'
    import FieldError from '../../../shared/FieldError.svelte'

    export let domain
    export let place
    export let active

    const constraints = {
        sheet       : { presence: { allowEmpty: false, message: "campo obrigatório" } },
        range       : { presence: { allowEmpty: false, message: "campo obrigatório" } },
        credentials : { presence: { allowEmpty: false, message: "campo obrigatório" } },
    }

    let config = {
        kind        : 'gdrive-sheets', 
        sheet       : active && active.sheet, 
        range       : active && active.range,
        credentials : active && active.credentials
    }
</script>
<Shared {domain} {place} {config} {constraints} let:working let:errors>
    <div class="field" 
         class:disabled={working} 
         class:error={errors.sheet}>
        <label>Arquivo</label>
        <input bind:value={config.sheet}>
        <FieldError style="label" property={errors.sheet} />
    </div>
    <div class="field" 
         class:disabled={working}
         class:error={errors.range}>
        <label>Intervalo</label>
        <input bind:value={config.range}>
        <FieldError style="label" property={errors.range} />
    </div>
</Shared>